import React, { Suspense } from 'react';

//Third party packages
import { useSelector } from 'react-redux';
import { Switch, Route, Routes } from 'react-router-dom';

import Layout from 'src/Member/components/Layout';
import PageNotFound from 'src/Components/PageNotFound';
import Dashboard from 'src/Member/components/dashboard/dashboard';

import '../Member/components/commonstyle.scss';
import PriceCompare from 'src/Member/components/pricecompare/PriceCompare';
//import SearchResults from 'src/Member/components/pricecompare/SearchResults';
import UploadDocument from 'src/Member/components/uploaddocument/UploadDocument';
import ViewAllDocuments from 'src/Member/components/uploaddocument/ViewAllDocuments';
import ViewDocument from 'src/Member/components/uploaddocument/ViewDocument';
import SearchResults from 'src/Member/components/pricecompare/search-result/SearchResults';
import ResultPage from 'src/Member/components/pricecompare/result-page/ResultPage';
import AllServiceRequest from 'src/Member/components/pricecompare/recent-search/all-service-request/AllServiceRequest';
import HelpCenter from 'src/Member/components/HelpCenter/HelpCenter';
import DetailIndexScreen from 'src/Member/components/Message&Documents/DetailIndexScreen';
import ClaimDetailsDoctorDetails from 'src/Member/components/claims/details/FacilityProviderDetails/doctor-details/ProviderDetails';
import ClaimDetailsFacilityDetails from 'src/Member/components/claims/details/FacilityProviderDetails/facility-details/FacilityDetails';
import DashboardAffiliateAccount from 'src/Member/components/affiliateaccount/DashboardAffiliateAccount';

const Claims = React.lazy(() => import('../Member/components/claims'));
const Accounts = React.lazy(() => import('../Member/components/accounts'));
const MyProfile = React.lazy(() => import('src/Member/components/my-profile'));
const MyIDCards = React.lazy(() =>
  import('../Member/components/myidcards/DownloadIDCard'),
);
const ProtectedRoute = React.lazy(() =>
  import('../Member/components/Login/ProtectedRoute'),
);
const ProtectedRouteLatest = React.lazy(() =>
  import('../Member/components/Login/ProtectedRouteLatest'),
);
const ClaimDetails = React.lazy(() =>
  import('../Member/components/claims/details/claimdetails'),
);
const ForgotPassword = React.lazy(() =>
  import('../Member/components/Login/forgotpassword'),
);
const WrapperRegisterComponent = React.lazy(() =>
  import('../Member/components/register/wrapperRegisterComponent'),
);
const RouteWrapper = React.lazy(() =>
  import('../Member/components/register/RouteWrapper'),
);
const WrapperResetPasswordComponent = React.lazy(() =>
  import('../Member/components/passwordrecovery/wrapperResetPasswordComponent'),
);
const Register = React.lazy(() =>
  import('../Member/components/register/register'),
);
const PasswordRecovery = React.lazy(() =>
  import('../Member/components/passwordrecovery/passwordrecovery'),
);
const coverageInfo = React.lazy(() =>
  import('../Member/components/register/coverageInfo'),
);
const WorkInProgress = React.lazy(() =>
  import('../Member/components/Login/workinprogress'),
);
const DashboardWorkInProgress = React.lazy(() =>
  import('../Member/components/dashboard/dashboard_workinprogress'),
);
const CoverageDetails = React.lazy(() =>
  import('../Member/components/coverage'),
);
const ServerError = React.lazy(() =>
  import('../Member/errorhandling/ServerError'),
);
const ClientError = React.lazy(() =>
  import('../Member/errorhandling/ClientError'),
);
const ClientErrorWidget = React.lazy(() =>
  import('../Member/errorhandling/ClientErrorWidget'),
);
const OTPError = React.lazy(() => import('../Member/errorhandling/OTPerror'));
const Payment = React.lazy(() =>
  import('../Member/components/payment/payment'),
);
const RegisterSuccess = React.lazy(() =>
  import('../Member/components/register/registerSuccess'),
);
const TwoStepAuthentication = React.lazy(() =>
  import('../Member/components/register/twoStepAuthentication'),
);
const OneTimePassword = React.lazy(() =>
  import('../Member/components/register/oneTimePassword'),
);
const OTPRegisterSuccess = React.lazy(() =>
  import('../Member/components/register/otpRegisterSuccess'),
);
const LoginOTP = React.lazy(() =>
  import('../Member/components/Login/loginOTP'),
);
const EmailRecoverySuccess = React.lazy(() =>
  import('../Member/components/emailrecovery/emailrecoverysuccess'),
);
const PageContent = React.lazy(() =>
  import('../Member/components/PageContent'),
);
const ResourcePageContent = React.lazy(() =>
  import('../Member/components/Resources/ResourcePageContent'),
);
const ResourceDocumentContent = React.lazy(() =>
  import('../Member/components/Resources/ResourceDocumentContent'),
);
const DocumentContent = React.lazy(() =>
  import('../Member/components/DocumentContent'),
);
const ViewAllResources = React.lazy(() =>
  import('../Member/components/Resources/ViewAllResources'),
);
const FindProvider = React.lazy(() =>
  import('../Member/components/find-provider'),
);
const DoctorDetails = React.lazy(() =>
  import(
    '../Member/components/find-provider/find-doctor/doctor-details/ProviderDetails'
  ),
);
const PriceCompareDoctorDetails = React.lazy(() =>
  import(
    '../Member/components/pricecompare/find-doctor/doctor-details/ProviderDetails'
  ),
);
const PriceCompareFacilityDetails = React.lazy(() =>
  import(
    '../Member/components/pricecompare/find-doctor/facility-details/FacilityDetails'
  ),
);
const LoginPage = React.lazy(() =>
  import('../Member/components/Login/LoginPage'),
);
const ChangePassword = React.lazy(() =>
  import('../Member/components/Login/ChangePassword'),
);

const MenuTabs = React.lazy(() =>
  import('../Member/components/Login/menutabs'),
);
const Logout = React.lazy(() => import('../Member/components/logout/logout'));
const SessionLogout = React.lazy(() =>
  import('../Member/components/logout/SessionLogout'),
);
const EmailRecovery = React.lazy(() =>
  import('../Member/components/emailrecovery/emailrecovery'),
);
const FacilityDetails = React.lazy(() =>
  import(
    '../Member/components/find-provider/find-facility/facility-details/FacilityDetails'
  ),
);
const EnrollmentLifeEvent = React.lazy(() =>
  import('../Member/components/enrollment/EnrollmentLifeEvent'),
);
const EnrollmentCoverageFlow = React.lazy(() =>
  import(
    '../Member/components/enrollment/components/enrollment-coverage-flow/EnrollmentCoverageFlow'
  ),
);

const EnrollmentSuccess = React.lazy(() =>
  import(
    '../Member/components/enrollment/components/enrollment-success/EnrollmentSuccess'
  ),
);
import TalonIntegration from 'src/Member/components/talon/TalonIntegration';
import AccountUnlockScreen from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockScreen';
import AccountUnlockRecovery from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockRecovery';
import AccountUnlockRecoveryResponse from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockRecoveryResponse';
import AccountUnlockVerifyLink from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockVerifyLink';
import AccountUnlockOtp from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockOtp';
import AccountUnlockResetPassword from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockResetPassword';
import AccountUnlockSuccessPage from 'src/Member/components/MemberServiceAccountUnlock/AccountUnlockSuccessPage';

export default function () {
  const is404Error = useSelector(({ app }) => app.is404Error);

  return (
    !is404Error && (
      <Layout>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/member/" element={<LoginPage />} />
            <Route
              path="/member/forgot-password"
              element={<ForgotPassword />}
            />
            <Route
              path="/member/change-password"
              element={<ChangePassword />}
            />
            {/*<Route
              path="/member/register/:approvalId?"
              element={
                <WrapperRegisterComponent>
                  <Register />
                </WrapperRegisterComponent>
              }
            /> */}
            <Route element={<WrapperRegisterComponent />}>
              <Route
                path="/member/register/:approvalId?"
                element={<RouteWrapper Component={Register} />}
              />

              <Route
                path="/member/register/:emailLinkVerification/:approvalId"
                element={<RouteWrapper Component={Register} />}
              />
            </Route>
            <Route path="/member/coverage-info" element={<coverageInfo />} />
            <Route
              path="/member/work-in-progress"
              element={<WorkInProgress />}
            />
            <Route path="/member/logout" element={<Logout />} />
            <Route path="/member/session-expired" element={<SessionLogout />} />
            <Route path="/member/server-error" element={<ServerError />} />
            <Route path="/member/client-error" element={<ClientError />} />
            <Route
              path="/member/client-error-widget"
              element={<ClientErrorWidget />}
            />
            <Route path="/member/otp-error" element={<OTPError />} />
            <Route path="/member/payment" element={<Payment />} />
            <Route
              path="/member/register-success"
              element={<RegisterSuccess />}
            />
            <Route
              path="/member/two-step-authentication"
              element={<TwoStepAuthentication />}
            />
            <Route
              path="/member/one-time-password"
              element={<OneTimePassword />}
            />
            <Route
              path="/member/otp-register-success"
              element={<OTPRegisterSuccess />}
            />
            <Route path="/member/login-otp" element={<LoginOTP />} />
            {/*<Route
              path="/member/password-recovery"
              element={<PasswordRecovery />}
            /> */}

            <Route
              path="/member/password-recovery/:resetPasswordLinkId?"
              element={
                <WrapperResetPasswordComponent Component={PasswordRecovery} />
              }
            />
            <Route path="/member/email-recovery" element={<EmailRecovery />} />
            <Route
              path="/member/email-recovery-success"
              element={<EmailRecoverySuccess />}
            />
            <Route
              path="/member/account-unlock"
              element={<AccountUnlockScreen />}
            />
            <Route
              path="/member/account-unlock-recovery"
              element={<AccountUnlockRecovery />}
            />
            <Route
              path="/member/account-unlock-response"
              element={<AccountUnlockRecoveryResponse />}
            />
            <Route
              path="/member/account-unlock-verify-link/:slug"
              element={<AccountUnlockVerifyLink />}
            />
            <Route
              path="/member/account-unlock-otp"
              element={<AccountUnlockOtp />}
            />
            <Route
              path="/member/account-unlock-reset-password"
              element={<AccountUnlockResetPassword />}
            />
            <Route
              path="/member/account-unlock-success"
              element={<AccountUnlockSuccessPage />}
            />
            <Route path="/member/page/:slug" element={<PageContent />} />
            <Route
              path="/member/document/:slug"
              element={<DocumentContent />}
            />

            <Route element={<ProtectedRouteLatest />}>
              <Route path="/member/my-profile" element={<MyProfile />} />
              <Route
                path="/member/affiliate-account"
                element={<DashboardAffiliateAccount />}
              />
              <Route path="/member/my-id-cards" element={<MyIDCards />} />
              <Route path="/member/dashboard" element={<Dashboard />} />
              <Route path="/member/menu-tabs" element={<MenuTabs />} />
              <Route
                path="/member/dashboard-work-in-progress"
                element={<DashboardWorkInProgress />}
              />
              <Route path="/member/price-compare" element={<PriceCompare />} />
              <Route
                path="/member/price-compare/search-results"
                element={<SearchResults />}
              />
              <Route
                path="/member/price-compare/show-result"
                element={<ResultPage />}
              />
              <Route
                path="/member/price-compare/show-result/:id"
                element={<ResultPage />}
              />
              <Route
                path="/member/price-compare/doctor-details/:id/:coord"
                element={<PriceCompareDoctorDetails />}
              />
              <Route
                path="/member/price-compare/facility-details/:id/:coord"
                element={<PriceCompareFacilityDetails />}
              />
              <Route
                path="/member/price-compare/all-service-request"
                element={<AllServiceRequest />}
              />
              <Route
                path="/member/upload-document"
                element={<UploadDocument />}
              />
              {/*<Route
                path="/member/view-all-documents"
                element={<ViewAllDocuments />}
              /> */}
              <Route path="/member/view-documents" element={<ViewDocument />} />
              <Route path="/member/help-center" element={<HelpCenter />} />
              <Route
                path="/member/messages-documents-notifications"
                element={<DetailIndexScreen />}
              />
              <Route
                path="/member/enrollment-life-event"
                element={<EnrollmentLifeEvent />}
              />
              <Route
                path="/member/enrollment-coverage"
                element={<EnrollmentCoverageFlow />}
              />
              <Route
                path="/member/enrollment-success"
                element={<EnrollmentSuccess />}
              />
              <Route
                path="/member/resource/:slug"
                element={<ResourcePageContent />}
              />
              <Route
                path="/member/document/:slug"
                element={<ResourceDocumentContent />}
              />
            </Route>

            <Route
              element={<ProtectedRouteLatest permissionName="View Claims" />}
            >
              <Route path="/member/claims" element={<Claims />} />
              <Route path="/member/claim-details" element={<ClaimDetails />} />
            </Route>
            <Route
              path="/member/claim-details/facility-details/:id"
              element={<ClaimDetailsFacilityDetails />}
            />
            <Route
              path="/member/claim-details/doctor-details/:id"
              element={<ClaimDetailsDoctorDetails />}
            />
            <Route
              element={<ProtectedRouteLatest permissionName="Account Types" />}
            >
              <Route path="/member/accounts" element={<Accounts />} />
            </Route>

            <Route
              element={
                <ProtectedRouteLatest permissionName="View Coverage Details" />
              }
            >
              <Route path="/member/coverage" element={<CoverageDetails />} />
            </Route>

            {/*<Route
              element={<ProtectedRouteLatest permissionName="View Resource" />}
            > */}
            <Route path="/member/allresources" element={<ViewAllResources />} />
            {/*</Route> */}

            <Route
              element={
                <ProtectedRouteLatest permissionName="Access to Find Provider Tool" />
              }
            >
              <Route path="/member/find-provider" element={<FindProvider />} />
              <Route
                path="/member/find-provider/doctor-details/:id/:coord"
                element={<DoctorDetails />}
              />
              <Route
                path="/member/find-provider/facility-details/:id/:coord"
                element={<FacilityDetails />}
              />
            </Route>
            <Route
              path="/member/cost-estimator"
              element={<TalonIntegration />}
            />

            {/*



          <ProtectedRoute exact path="/member/claim-details" element={ <ClaimDetails /> } permissionName = "View Claims" />


          <ProtectedRoute exact path="/member/allresources" element={ <ViewAllResources /> } permissionName = {'View Resource' } />
          <ProtectedRoute exact path="/member/find-provider" element={ <FindProvider /> } permissionName = {'Find Provider Details' } />
          <ProtectedRoute exact path="/member/doctor-details/:id/:coord" element={ <DoctorDetails /> } permissionName = {'Find Provider Details' } />
          <ProtectedRoute exact path="/member/facility-details/:id/:coord" element={ <FacilityDetails /> } permissionName = {'Find Provider Details'}/>
           */}
            <Route
              path="/member/*"
              element={(property) => {
                const pathname = property.location.pathname;
                return <PageNotFound pathname={pathname} from="member" />;
              }}
            />
          </Routes>
        </Suspense>
      </Layout>
    )
  );
}
